import { cn } from '@poseidon/components/cn';
import { omit } from 'lodash-es';
import Link from 'next/link';

import { type BreadcrumbLinkProps } from './Breadcrumbs';

export default function BreadcrumbLink({
  children,
  className,
  href,
  ...props
}: BreadcrumbLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        'flex flex-row items-center gap-2 text-nowrap text-sm hover:underline',
        'text-[#475166] dark:text-white',
        className,
      )}
      {...omit(props, ['backwards'])}>
      {children}
    </Link>
  );
}
